module.exports = __webpack_public_path__ + "c97f4c4b699c92e6884d34a07e0b1c05.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-sunny-lake.png
// module id = 1013
// module chunks = 0